import videojs from 'video.js';
import 'videojs-contrib-quality-levels';
import ConcreteButton from './concrete-button';
import ConcreteMenuItem from './concrete-menu-item';
const Plugin = videojs.getPlugin('plugin');
export class HlsQualitySelectorPlugin extends Plugin {
    player;
    config;
    _qualityButton;
    static get VERSION() {
        return '3.0.0';
    }
    constructor(player, options = {}) {
        super(player);
        this.player = player;
        this.config = options;
        player.ready(() => {
            player.addClass('vjs-hls-quality-selector');
        });
        if (this.player.qualityLevels() && this.getHls()) {
            this.createQualityButton();
            this.bindPlayerEvents();
        }
    }
    getHls() {
        return this.player.tech({ IWillNotUseThisInPlugins: true }).hls;
    }
    bindPlayerEvents() {
        this.player.qualityLevels().on('addqualitylevel', this.onAddQualityLevel.bind(this));
    }
    createQualityButton() {
        const { player } = this;
        const { placementIndex = player.controlBar.children().length - 2 } = this.config;
        this._qualityButton = new ConcreteButton(player);
        const concreteButtonInstance = player.controlBar.addChild(this._qualityButton, { componentClass: 'qualitySelector' }, placementIndex);
        concreteButtonInstance.addClass('vjs-quality-selector');
        if (!this.config.displayCurrentQuality) {
            const icon = ` ${this.config.vjsIconClass || 'vjs-icon-hd'}`;
            concreteButtonInstance.menuButton_.$('.vjs-icon-placeholder').className += icon;
        }
        else {
            this.setButtonInnerText('auto');
        }
        concreteButtonInstance.removeClass('vjs-hidden');
    }
    setButtonInnerText(text) {
        this._qualityButton.menuButton_.$('.vjs-icon-placeholder').innerHTML = text;
    }
    getQualityMenuItem(item) {
        const { player } = this;
        return new ConcreteMenuItem(player, item, this._qualityButton, this);
    }
    onAddQualityLevel() {
        const { player } = this;
        const qualityList = player.qualityLevels();
        const levels = qualityList.levels_ || [];
        const levelItems = [];
        for (let i = 0; i < levels.length; ++i) {
            if (!levelItems.filter((_existingItem) => {
                return _existingItem.item && _existingItem.item.value === levels[i].height;
            }).length) {
                const levelItem = this.getQualityMenuItem({
                    label: levels[i].height + 'p',
                    value: levels[i].height
                });
                levelItems.push(levelItem);
            }
        }
        levelItems.sort((current, next) => {
            if (typeof current !== 'object' || typeof next !== 'object') {
                return -1;
            }
            if (current.item.value < next.item.value) {
                return -1;
            }
            if (current.item.value > next.item.value) {
                return 1;
            }
            return 0;
        });
        levelItems.push(this.getQualityMenuItem.call(this, {
            label: player.localize('Auto'),
            value: 'auto',
            selected: true
        }));
        if (this._qualityButton) {
            this._qualityButton.createItems = function () {
                return levelItems;
            };
            this._qualityButton.update();
        }
    }
    setQuality(height) {
        const qualityList = this.player.qualityLevels();
        if (this.config.displayCurrentQuality) {
            this.setButtonInnerText(height === 'auto' ? height : `${height}p`);
        }
        for (let i = 0; i < qualityList.length; ++i) {
            const quality = qualityList[i];
            quality.enabled = quality.height === height || height === 'auto';
        }
        this._qualityButton.unpressButton();
    }
}
videojs.registerPlugin('hlsQualitySelector', HlsQualitySelectorPlugin);
